import Button from '@mui/material/Button';
import Styles from './styles/SaveBanner.module.css'
import { useMediaQuery } from 'react-responsive';
import { useNavigate } from 'react-router-dom';
import Confirmation from './Confirmation';
import { useState } from 'react';
import EasySnackBar from './EasySnackBar';

export default function SaveBanner(props) {

    const navigate = useNavigate()
    const [showConfirmation, setShowConfirmation] = useState(false)

    const [errorMessage, setErrorMessage] = useState('')
    const [successMessage, setSuccessMessage] = useState('')

    const bigScreen = useMediaQuery({
        query: '(min-width: 600px)'
    })

    return (
        <>
            <div className={Styles.spacer}>
                <Confirmation
                    action={() => { props.setPreventNavigation(false); navigate('/admin/app') }}
                    rejectAction={props.rejectAction}
                    open={showConfirmation}
                    setOpen={setShowConfirmation}
                    title={"Tienes cambios sin guardar"}
                    description={"Estas seguro de que quieres descartar los cambios?"}
                    actionMsg={"Descartar"}
                    rejectMsg={"Volver"}
                />

                <div className={Styles.container} style={{ width: bigScreen ? 'calc(100% - 240px)' : '100%' }}>

                    <Button
                        variant='contained'
                        sx={{ width: '35%' }}
                        color='error'
                        onClick={props.storeModified ? setShowConfirmation.bind(this, true) : navigate.bind(this, '/admin/app')}
                    >
                        Descartar
                    </Button>

                    <Button
                        variant='contained'
                        sx={{ width: '35%' }}
                        onClick={() => {
                            if (props.preventUpdate) {
                                setErrorMessage(props.preventedUpdateMessage)
                            } else {
                                props.onUpdate()
                                setSuccessMessage('Guardado correctamente')
                            }
                        }}
                        disabled={props.storeModified ? false : true}
                    >
                        Guardar
                    </Button>
                </div >
            </div>

            <EasySnackBar
                severity='error'
                key='1'
                message={errorMessage}
                setMessage={setErrorMessage}
            />

            <EasySnackBar
                severity='success'
                key='2'
                message={successMessage}
                setMessage={setSuccessMessage}
            />
        </>
    )
}